import { ResetPassword } from 'components/containers';

export default function ResetPasswordPage() {
  return <ResetPassword />;
}
